module.exports = __webpack_public_path__ + "files/f5a93efd142cd455d2f3d2b6cfa0e17e.gif";


//////////////////
// WEBPACK FOOTER
// ./images/tutorialTipWhite.gif
// module id = 1838
// module chunks = 60